import React from "react";

let isFullScreenContext = React.createContext(false)

export default isFullScreenContext